import { ModalToastProps } from "@int-traderjoes/ui-components-library";
import { sanitizeDisplayHtml } from "@/utils/sanitizeDisplayHtml";

export const formatApiErrorMessage = (
  message: string
): ModalToastProps => {
  const containsHtml = /<\/?[a-z][^>]*>/i.test(message);

  if (!containsHtml) {
    return {
      type: "error",
      autoClose: true,
      message,
    };
  }

  const sanitized = sanitizeDisplayHtml(message);

  return {
    type: "error",
    message: "",
    autoClose: true,
    content: (
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
        }}
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />
    ),
  };
};